export const CART_STORAGE_KEY = "cart";
export const CART_UPDATED_EVENT = "cartUpdated";

function canUseStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function readCart() {
  if (!canUseStorage()) {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(CART_STORAGE_KEY);
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Failed to read cart:", error);
    return [];
  }
}

export function writeCart(items) {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
}

export function emitCartUpdated() {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
}

function isSameLineItem(item, incoming) {
  return item.productId === incoming.productId && (item.size || null) === (incoming.size || null);
}

export function addToCart(item) {
  const cart = readCart();
  const index = cart.findIndex((entry) => isSameLineItem(entry, item));

  if (index >= 0) {
    const updatedQuantity = (cart[index].quantity || 0) + (item.quantity || 1);
    cart[index] = { ...cart[index], quantity: updatedQuantity };
  } else {
    cart.push({ ...item, quantity: item.quantity || 1 });
  }

  writeCart(cart);
  emitCartUpdated();
  return cart;
}

export function updateCartQuantity(index, quantity) {
  const cart = readCart();
  if (index < 0 || index >= cart.length) {
    return cart;
  }

  const nextQuantity = Math.max(1, Number(quantity) || 1);
  cart[index] = { ...cart[index], quantity: nextQuantity };
  writeCart(cart);
  emitCartUpdated();
  return cart;
}

export function removeCartItem(index) {
  const cart = readCart();
  const nextCart = cart.filter((_, itemIndex) => itemIndex !== index);
  writeCart(nextCart);
  emitCartUpdated();
  return nextCart;
}

export function clearCart() {
  writeCart([]);
  emitCartUpdated();
}

export function getCartCount(items = readCart()) {
  return items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
}

export function getCartSubtotal(items = readCart()) {
  return items.reduce((sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 0), 0);
}
